"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.avatar.list': 'Avatares',
    'route.avatar.create': 'Agregar Avatar',
    'route.avatar.edit': 'Editar Avatar',
    'route.avatar.preview': 'Vista previa del avatar',
};
